module.exports = require("core-js-pure/features/weak-set");